import { render, staticRenderFns } from "./visitVolume.vue?vue&type=template&id=85aff29a&"
import script from "./visitVolume.vue?vue&type=script&lang=js&"
export * from "./visitVolume.vue?vue&type=script&lang=js&"
import style0 from "./visitVolume.vue?vue&type=style&index=0&id=85aff29a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports